__turbopack_context__.v({
  "active": "Header-module-scss-module__rZkXAq__active",
  "cart-button": "Header-module-scss-module__rZkXAq__cart-button",
  "cart-item-number": "Header-module-scss-module__rZkXAq__cart-item-number",
  "close-icon": "Header-module-scss-module__rZkXAq__close-icon",
  "consultant-avatar-button": "Header-module-scss-module__rZkXAq__consultant-avatar-button",
  "consultant-card": "Header-module-scss-module__rZkXAq__consultant-card",
  "consultant-card-body": "Header-module-scss-module__rZkXAq__consultant-card-body",
  "consultant-card-close-button": "Header-module-scss-module__rZkXAq__consultant-card-close-button",
  "consultant-card-header": "Header-module-scss-module__rZkXAq__consultant-card-header",
  "consultant-image": "Header-module-scss-module__rZkXAq__consultant-image",
  "consultant-name": "Header-module-scss-module__rZkXAq__consultant-name",
  "consultant-wrapper": "Header-module-scss-module__rZkXAq__consultant-wrapper",
  "container-bottom": "Header-module-scss-module__rZkXAq__container-bottom",
  "container-top": "Header-module-scss-module__rZkXAq__container-top",
  "desktop": "Header-module-scss-module__rZkXAq__desktop",
  "header": "Header-module-scss-module__rZkXAq__header",
  "header-bottom": "Header-module-scss-module__rZkXAq__header-bottom",
  "header-top": "Header-module-scss-module__rZkXAq__header-top",
  "logo": "Header-module-scss-module__rZkXAq__logo",
  "logo-wrapper": "Header-module-scss-module__rZkXAq__logo-wrapper",
  "mobile": "Header-module-scss-module__rZkXAq__mobile",
  "mobile-button": "Header-module-scss-module__rZkXAq__mobile-button",
  "mobile-search-button": "Header-module-scss-module__rZkXAq__mobile-search-button",
  "mobile-search-container": "Header-module-scss-module__rZkXAq__mobile-search-container",
  "navigation": "Header-module-scss-module__rZkXAq__navigation",
  "search-container": "Header-module-scss-module__rZkXAq__search-container",
});
